var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',[_c('template',{slot:"Title"},[_vm._v(" This looks empty ")]),_c('template',{slot:"SubTitle"}),_c('template',{slot:"Content"},[_vm._v(" You can upload tracks here ")]),_c('template',{slot:"Actions"},[_c('UploadButton')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }